import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import React, { useState } from "react";
import {
  Button,
} from "@mui/material";
import ListCuenta from "pages/account/ListCuenta";
import CreateAccountModal from "./CreateAccountModal";

const AccountsModal = ({
  open,
  codigoSocio,
  onClose,
}) => {
  const [refreshTrigger, setRefreshTrigger] = useState(true)

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="lg"
      fullWidth
    >
      <DialogTitle variant="h3">
        Listado de cuentas
      </DialogTitle>
      <DialogContent>
        <ListCuenta
          key={refreshTrigger.toString()}
          codigoSocio={codigoSocio}
        />
      </DialogContent>
      <DialogActions sx={{
        justifyContent: "space-between"
      }}>
        <Button onClick={onClose} autoFocus>
          Cerrar
        </Button>
        <CreateAccountModal
          codigoSocio={codigoSocio}
          onAccountAssigned={() => setRefreshTrigger(current => !current)}
        />
      </DialogActions>
    </Dialog>
  );
}

export default AccountsModal